import React, { useState } from "react";
import Logo from "../../assets/images/footer/footerlogo.png";
import Insta from "../../assets/images/footer/insta.png";
import Linkedin from "../../assets/images/footer/linkedin.png";
import Youtube from "../../assets/images/footer/youtube.png";
import { Link } from "react-router-dom";
import { subscribeNewsletter } from "../../ApiService";

function Footer() {
  const [email, setEmail] = useState("");
  const [isSubscribing, setIsSubscribing] = useState(false);
  const [subscribeMessage, setSubscribeMessage] = useState({ text: "", type: "" });

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      setSubscribeMessage({ text: "Please enter a valid email address", type: "error" });
      return;
    }

    setIsSubscribing(true);
    setSubscribeMessage({ text: "", type: "" });

    try {
      // Use the subscribeNewsletter API function
      const result = await subscribeNewsletter(email);
      
      setEmail("");
      setSubscribeMessage({ 
        text: result.message || "Thank you for subscribing!", 
        type: "success" 
      });
      
    } catch (error) {
      console.error("Subscription error:", error);
      
      setSubscribeMessage({ 
        text: "Subscription failed. Please try again later.", 
        type: "error" 
      });
    } finally {
      setIsSubscribing(false);
    }
  };

  return (
    <>
      <div
        className="container-fluid site-footer"
        style={{
          background: "#F1F5F8 0% 0% no-repeat padding-box",
          boxShadow: "0px 1px 0px #D4D4E3",
          borderTop: "1px solid #D4D4E3",
          opacity: 1,
        }}
      >
        <div className="row py-4">
          <div className="col">
            <div className="container">
              <div className="row">
                <div className="col-md-8 col-lg-7 col-12">
                  <div className="row">
                    <div className="col pb-3">
                      <Link to="/" aria-label="Simule home">
                        <img src={Logo} className="img-fluid" alt="Logo" />
                      </Link>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 col-md-4 pb-2">
                      <div className="footeroptions pb-1">
                        <Link to="/map" className="headeroptionslink">
                          Go to Map
                        </Link>
                      </div>
                      <div className="footeroptions pb-1">
                        <Link to="/whitepaper" className="headeroptionslink">
                          White Paper
                        </Link>
                      </div>
                      <div className="footeroptions pb-1">
                        <Link to="/help" className="headeroptionslink">
                          Help Center
                        </Link>
                      </div>
                    </div>
                    <div className="col-6 col-md-4 pb-2">
                      <div className="footeroptions pb-1">
                        <Link to="/login" className="headeroptionslink">
                          Login/Register
                        </Link>
                      </div>
                      {/* <div className="footeroptions pb-1">
                        <Link to="/map" className="headeroptionslink">
                          Marketplace
                        </Link>
                      </div> */}
                      <div className="footeroptions pb-1">
                        <Link to="/map" className="headeroptionslink">
                          Digital Collectibles
                        </Link>
                      </div>
                      <div className="footeroptions pb-1">
                        <Link to="/disclaimer" className="headeroptionslink">
                          Disclaimer
                        </Link>
                      </div>
                    </div>
                    <div className="col-12 col-md-4 pb-2">
                      <div className="footeroptions pb-1">
                        <Link to="/privacy" className="headeroptionslink">
                          Privacy Policy
                        </Link>
                      </div>
                      <div className="footeroptions pb-1">
                        <Link to="/terms" className="headeroptionslink">
                          Terms & Conditions
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-5 col-12">
                  <div className="row">
                    <div className="col pb-3">
                      <div className="headerboldtext">
                        Get latest updates in your inbox
                      </div>
                      <form onSubmit={handleSubscribe}>
                        <div className="my-2">
                          <input
                            type="email"
                            required
                            className="form-control inputboldtext"
                            id="exampleFormControlInput1"
                            placeholder="Your Email Address"
                            value={email}
                            onChange={handleEmailChange}
                          />
                        </div>
                        <button 
                          type="submit" 
                          className="footerbtn mt-1"
                          disabled={isSubscribing}
                        >
                          {isSubscribing ? "Subscribing..." : "Subscribe"}
                        </button>
                        {subscribeMessage.text && (
                          <div className={`mt-2 ${subscribeMessage.type === "error" ? "text-danger" : "text-success"}`}>
                            {subscribeMessage.text}
                          </div>
                        )}
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col text-center pt-4">
                  <nav className="footer-socials" aria-label="Simule social media">
                    <a
                      className="footer-social-link"
                      href="https://x.com/simule_?t=wBxH4eXUYVmSSiPbVEAqFQ&s=09"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Simule on X"
                    >
                      <svg className="footer-x-icon" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.65l-5.21-6.82-5.97 6.82H1.68l7.73-8.84L1.25 2.25h6.83l4.71 6.23 5.45-6.23Zm-1.16 17.52h1.83L7.08 4.13H5.12l11.96 15.64Z" />
                      </svg>
                    </a>
                    <a
                      className="footer-social-link"
                      href="https://www.linkedin.com/company/simule-io"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Simule on LinkedIn"
                    >
                      <img src={Linkedin} alt="" aria-hidden="true" />
                    </a>
                    <a
                      className="footer-social-link"
                      href="https://www.instagram.com/simule_com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Simule on Instagram"
                    >
                      <img src={Insta} alt="" aria-hidden="true" />
                    </a>
                    <a
                      className="footer-social-link"
                      href="https://www.youtube.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Simule on YouTube"
                    >
                      <img src={Youtube} alt="" aria-hidden="true" />
                    </a>
                  </nav>
                </div>
              </div>
              <div className="row">
                <div className="col text-center pt-2">
                  <div className="headersmalltext">© {new Date().getFullYear()} Simule</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
